import {createFeatureSelector, createSelector} from '@ngrx/store';
import {SharedFilterState} from './shared-filter.reducer';
import {IAdvancedFilterGroup} from '../../settings-new/models/general/advanced-filter-group.interface';
import {
  ADVANCED_FILTER_GRID_STOCK_TAKE,
  matchesAdvancedFilterGridCategory,
} from '../../settings-new/models/general/advanced-filter-grid.constants';

export const selectSharedState = createFeatureSelector<SharedFilterState>('shared-filter');

// ====================================================================================================
// Advanced Filter Group
// ====================================================================================================
export const selectAdvancedFilterGroups = createSelector(
  selectSharedState,
  (state: SharedFilterState) => state.advancedFilterGroups
);

export const selectAppliedAdvancedFilterGroup = createSelector(
  selectSharedState,
  (state: SharedFilterState) => state.appliedAdvancedFilterGroup ?? null,
);

export const selectAdvancedFilterGroupGrid = createSelector(
  selectSharedState,
  (state: SharedFilterState) => state.selectedAdvancedFilterGroupGrid
);

export const selectAdvancedFilterGroupsBySelectedGrid = createSelector(
  selectSharedState,
  selectAdvancedFilterGroupGrid,
  (state: SharedFilterState, grid: string) =>
    state.advancedFilterGroups.filter((afg: IAdvancedFilterGroup): boolean =>
      matchesAdvancedFilterGridCategory(afg.grid, grid),
    ),
);

/**
 * Saved Stock Take advanced filters only (`grid: 'stock-take'`).
 */
export const selectStockTakeAdvancedFilterGroups = createSelector(
  selectAdvancedFilterGroups,
  (groups: IAdvancedFilterGroup[]) =>
    groups.filter(
      (afg: IAdvancedFilterGroup): boolean =>
        !!afg.saved && matchesAdvancedFilterGridCategory(afg.grid, ADVANCED_FILTER_GRID_STOCK_TAKE),
    ),
);

export const selectIsAdvancedFilterGroupsLoading = createSelector(
  selectSharedState,
  (state: SharedFilterState) => state.isAdvancedFilterGroupLoading
);

export const selectSelectedAdvancedFilterGroup = createSelector(
  selectSharedState,
  (state: SharedFilterState) => state.selectedAdvancedFilterGroup
);

export const selectSelectedAdvancedFilterGroupFilterGroups = createSelector(
  selectSelectedAdvancedFilterGroup,
  (filterGroup: IAdvancedFilterGroup) => filterGroup?.filterGroup || undefined
);
